import type {LinkProps} from '@jetbrains/ring-ui/components/link/link'

import Link from '../components/common/Link/Link'
import {getClassicOverviewHrefWithCustomBase} from '../routes'
import type {BuildTypeId, FederationServerId, ProjectId} from '../types'

type Props = LinkProps & {
  projectId?: ProjectId | null | undefined
  buildTypeId?: BuildTypeId | null | undefined
  serverId: FederationServerId
  isAdmin: boolean
  isTemplate: boolean
}
function ProjectOrBuildTypeExternalLink({
  projectId,
  buildTypeId,
  serverId,
  isAdmin,
  isTemplate,
  ...restProps
}: Props) {
  return (
    <Link
      href={getClassicOverviewHrefWithCustomBase({
        projectId,
        buildTypeId,
        serverId,
        isAdmin,
        isTemplate,
      })}
      {...restProps}
    />
  )
}
export default ProjectOrBuildTypeExternalLink
